export const config = {
  API_URL: window.API_ENDPOINT || import.meta.env.VITE_REACT_API_END_POINT,
  URL_ENDPOINT: window.URL_ENDPOINT || "http://localhost:5173"
};
